export default "__VITE_ASSET__DcW$0JLu__"